import { useContext } from "react";
import { AvisForm } from "../../shared/components";
import { AvisDescriptiveText, AvisSection } from "../../shared/components/form";
import { AvisContext } from "../../shared/context/AvisContext";
import { LinkedPersonsBailiffs } from "./LinkedPersonsBailiffs";
import { LinkedPersonsList } from "./LinkedPersonsList";

export function LinkedPersonsPage() {
  const { res } = useContext(AvisContext);

  return (
    <AvisForm title={res("authors_LinkedPersonsPage_Title")}>
      <AvisDescriptiveText textKey="portal_RH_LinkedPerson_1" />
      <AvisSection title={res("authors_LinkedPersonsPage_SectionPersonsTitle")}>
        <LinkedPersonsList />
      </AvisSection>
      <AvisSection
        title={res("authors_LinkedPersonsPage_SectionBailiffsTitle")}
      >
        <LinkedPersonsBailiffs />
      </AvisSection>
    </AvisForm>
  );
}
